export const SearchSize = {
  SMALL: "small",
  LARGE: "large",
};

export const SearchVariant = {
  DEFAULT: "default",
  GHOST: "ghost",
};
